export const firestore_config = {
  pearent: "ivents"
};
